import * as React from 'react';
import { TimelineItem } from '../index';
export default class Timeline extends React.Component {
    constructor() {
        super(...arguments);
        this.renderContent = () => {
            const { items, children } = this.props;
            if (items) {
                return this.renderItems(items);
            }
            return React.Children.map(children, (item) => {
                if (React.isValidElement(item) && item.type === TimelineItem) {
                    return item;
                }
            });
        };
    }
    BEM() {
        const classArray = ['timeline'];
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    renderItems(items) {
        return items.map((item, index) => React.createElement(TimelineItem, Object.assign({ key: index }, item)));
    }
    render() {
        return React.createElement("div", { className: this.BEM() }, this.renderContent());
    }
}
